import React from "react";
import ElementsForm from "@/components/stripe/ElementsForm";
import {
  Flex,
} from "@chakra-ui/react";

const AddPaymentDetailModal = ({ isNext, setIsNext,userData}) => {
  return (<Flex w="100%" flexDirection="column"  maxH="500px">
      <ElementsForm
        isNext={isNext} 
        setIsNext={setIsNext}
        userData={userData}
      />
    </Flex>    
  );
};

export default AddPaymentDetailModal;
